/*
    *服务 接口
    *和后端交互的接口
    *
    *
*/

import { Common } from '@/utils/http';
import { SERVICE_CODE, STATE_CODE } from '@/config/interface';
import {
  BASE_CONFIG
} from '@/config/config'
import axios from 'axios'
import { Message } from 'element-ui';
let InterfaceService = {

  loginOut: (params, callback, errorCallback, loadingStartCb, loadingEndCb) => {
    Common.request(SERVICE_CODE.LOGOUT, params, (data) => {
      console.log('退出登录');

      sessionStorage.removeItem('user');//登出 清空缓存信息
      typeof callback === 'function' && callback(data);
    }, (data) => {
      typeof errorCallback === 'function' && errorCallback(data);
    }, loadingStartCb, loadingEndCb);
  },

  testInter: (params, callback, errorCallback, loadingStartCb, loadingEndCb) => {
    Common.request(SERVICE_CODE.TEST_CODE, params, (data) => {
      typeof callback === 'function' && callback(data);
    }, (data) => {
      typeof errorCallback === 'function' && errorCallback(data);
    }, loadingStartCb, loadingEndCb);
  },
  //首页 产品 oss
  getHomeProdList: (callback) => {

    axios.get(BASE_CONFIG.OSS_SERVICE_ADDRESS + '/djc/statics/category/pd_category_info.json')
      .then(response => {
        // console.log(response)
        if (response.status === 200) {
          //   console.log(response)
          typeof callback === 'function' && callback(response.data);
        }
      })
  },
  getBidSearchConfig: (callback) => {

    axios.get(BASE_CONFIG.OSS_SERVICE_ADDRESS + '/statics/category/bidSearchConfig.json')
      .then(response => {
        // console.log(response)
        if (response.status === 200) {
          //   console.log(response)
          typeof callback === 'function' && callback(response.data);
        }
      })
  },


}
const interMap = [
  { method: 'getLoginFlg', code: '020012', showMsg: true }, // 查询登录用户
  { method: 'getCategoryList', code: '030103', showMsg: true },
  { method: 'getCategoryOfBidWinning', code: '03010015' }, // 获取已存在类目
];
let interAPI = {};

interMap.forEach(m => {
  interAPI[m.method] = (params, callback, errorCallback, loadingStartCb, loadingEndCb) => {
    Common.request(m.code, params, (data) => {
      //console.log(data)
      typeof callback === 'function' && callback(data);
    }, (data) => {
      data = data || {}
      if (m.showMsg && data && data.respData && data.respData.respMsg) {
        Message.error(data.respData.respMsg);
      } else if (m.showError && data.respData && data.respData.respCode === '9999' && data.respData.respMsg) {
        Message.error(data.respData.respMsg);
      }
      typeof errorCallback === 'function' && errorCallback(data);
    }, loadingStartCb, loadingEndCb);
  }
});
Object.assign(InterfaceService, interAPI);
export { InterfaceService };



// WEBPACK FOOTER //
// ./src/services/api.js